"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _auth = require("@/utils/auth");
var MutationTypes = _interopRequireWildcard(require("../mutation-types"));
var _helpers = require("@/helpers");
var _auth2 = _interopRequireDefault(require("@/services/auth.service"));
var _underLoading = require("../helpers/under-loading");
var _others = _interopRequireDefault(require("@/services/others.service"));
var _authGuard = require("@/auth/authGuard");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t7 in e) "default" !== _t7 && {}.hasOwnProperty.call(e, _t7) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t7)) && (i.get || i.set) ? o(f, _t7, i) : f[_t7] = e[_t7]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var state = {
  token: '',
  roles: [],
  user: {}
};
var mutations = _defineProperty(_defineProperty({}, MutationTypes.SET_TOKEN, function (mutationState, token) {
  mutationState.token = token;
}), MutationTypes.SET_ROLES, function (mutationState, roles) {
  mutationState.roles = roles;
});
var actions = {
  login: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref, payload) {
      var commit, _yield$AuthService$lo, data, _data$data, token, user, businessUnits, dataValidator, active, dataUserAccess, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            commit = _ref.commit;
            _context.p = 1;
            _context.n = 2;
            return _auth2.default.login(payload);
          case 2:
            _yield$AuthService$lo = _context.v;
            data = _yield$AuthService$lo.data;
            _data$data = data.data, token = _data$data.token, user = _data$data.user, businessUnits = _data$data.businessUnits, dataValidator = _data$data.dataValidator; // SET DATA
            _context.n = 3;
            return (0, _auth.setToken)({
              token: token,
              user: user,
              dataValidator: dataValidator
            });
          case 3:
            commit(MutationTypes.SET_TOKEN, token);
            active = (businessUnits === null || businessUnits === void 0 ? void 0 : businessUnits.length) === 1 ? businessUnits[0] : null; // SET DATA
            dataUserAccess = {
              activeBusinessUnit: active,
              businessUnits: businessUnits
            };
            _context.n = 4;
            return (0, _auth.setAccessDataCookie)(token);
          case 4:
            if ((0, _authGuard.isUserAdmin)()) {
              _context.n = 5;
              break;
            }
            _context.n = 5;
            return (0, _auth.setAccessDataLocalStorage)(dataUserAccess);
          case 5:
            _context.n = 6;
            return (0, _auth.setAccessDataLocalStorage)('access');
          case 6:
            return _context.a(2, data);
          case 7:
            _context.p = 7;
            _t = _context.v;
            console.log('error: ', _t);
            _helpers.errorResponseHelper.display(_t);
            return _context.a(2, false);
        }
      }, _callee, null, [[1, 7]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }()),
  logout: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(context) {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            return _context2.a(2, new Promise(function (resolve, reject) {
              context.commit(MutationTypes.SET_TOKEN, '');
              context.commit(MutationTypes.SET_ROLES, []);
              context.commit(MutationTypes.RESET_ASSETS_STATE);
              context.commit(MutationTypes.RESET_MONITOR_STATE);
              (0, _auth.removeToken)();
              resolve(true);
            }));
        }
      }, _callee2);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }()),
  resetTokenAccess: function resetTokenAccess(_ref4) {
    var commit = _ref4.commit;
    return new Promise(function (resolve) {
      commit(MutationTypes.SET_TOKEN, '');
      commit(MutationTypes.SET_ROLES, []);
      resolve(true);
    });
  },
  setAccessData: function () {
    var _setAccessData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref5, payload) {
      var commit;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            commit = _ref5.commit;
            return _context4.a(2, new Promise(/*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(resolve) {
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      _context3.n = 1;
                      return (0, _auth.setAccessDataLocalStorage)({
                        activeBusinessUnit: payload.activeBusinessUnit,
                        businessUnits: payload.businessUnits
                      });
                    case 1:
                      (0, _auth.updateToken)(payload.token);
                      resolve(true);
                    case 2:
                      return _context3.a(2);
                  }
                }, _callee3);
              }));
              return function (_x6) {
                return _ref6.apply(this, arguments);
              };
            }()));
        }
      }, _callee4);
    }));
    function setAccessData(_x4, _x5) {
      return _setAccessData.apply(this, arguments);
    }
    return setAccessData;
  }(),
  fetchZip: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(_ref7, payload) {
      var commit, zip, _yield$OthersService$, data, _t2;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            commit = _ref7.commit;
            _context5.p = 1;
            zip = payload.replace('-', '').replace('.', '');
            _context5.n = 2;
            return _others.default.fetchZipCode(zip);
          case 2:
            _yield$OthersService$ = _context5.v;
            data = _yield$OthersService$.data;
            return _context5.a(2, data);
          case 3:
            _context5.p = 3;
            _t2 = _context5.v;
            console.log(_t2);
            _helpers.errorResponseHelper.display(_t2);
            return _context5.a(2, false);
        }
      }, _callee5, null, [[1, 3]]);
    }));
    return function (_x7, _x8) {
      return _ref8.apply(this, arguments);
    };
  }()),
  passChange: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(_ref9, payload) {
      var commit, _yield$AuthService$pa, data, _t3;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            commit = _ref9.commit;
            _context6.p = 1;
            _context6.n = 2;
            return _auth2.default.passChange(payload);
          case 2:
            _yield$AuthService$pa = _context6.v;
            data = _yield$AuthService$pa.data;
            return _context6.a(2, data);
          case 3:
            _context6.p = 3;
            _t3 = _context6.v;
            _helpers.errorResponseHelper.display(_t3);
            return _context6.a(2, false);
        }
      }, _callee6, null, [[1, 3]]);
    }));
    return function (_x9, _x0) {
      return _ref0.apply(this, arguments);
    };
  }()),
  recoveryPass: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(_ref1, payload) {
      var commit, _yield$AuthService$re, data, _t4;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            commit = _ref1.commit;
            _context7.p = 1;
            _context7.n = 2;
            return _auth2.default.recoveryPass(payload);
          case 2:
            _yield$AuthService$re = _context7.v;
            data = _yield$AuthService$re.data;
            return _context7.a(2, data);
          case 3:
            _context7.p = 3;
            _t4 = _context7.v;
            console.log(_t4);
            _helpers.errorResponseHelper.display(_t4);
            return _context7.a(2, false);
        }
      }, _callee7, null, [[1, 3]]);
    }));
    return function (_x1, _x10) {
      return _ref10.apply(this, arguments);
    };
  }()),
  resetPass: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(_ref11, payload) {
      var commit, _yield$AuthService$re2, data, _t5;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.p = _context8.n) {
          case 0:
            commit = _ref11.commit;
            _context8.p = 1;
            _context8.n = 2;
            return _auth2.default.resetPass(payload);
          case 2:
            _yield$AuthService$re2 = _context8.v;
            data = _yield$AuthService$re2.data;
            return _context8.a(2, data);
          case 3:
            _context8.p = 3;
            _t5 = _context8.v;
            console.log(_t5);
            _helpers.errorResponseHelper.display(_t5);
            return _context8.a(2, false);
        }
      }, _callee8, null, [[1, 3]]);
    }));
    return function (_x11, _x12) {
      return _ref12.apply(this, arguments);
    };
  }()),
  resetPassUserAPP: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(_ref13, payload) {
      var commit, _yield$AuthService$re3, data, _t6;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.p = _context9.n) {
          case 0:
            commit = _ref13.commit;
            _context9.p = 1;
            _context9.n = 2;
            return _auth2.default.resetPassUserAPP(payload);
          case 2:
            _yield$AuthService$re3 = _context9.v;
            data = _yield$AuthService$re3.data;
            return _context9.a(2, data);
          case 3:
            _context9.p = 3;
            _t6 = _context9.v;
            console.log(_t6);
            _helpers.errorResponseHelper.display(_t6);
            return _context9.a(2, false);
        }
      }, _callee9, null, [[1, 3]]);
    }));
    return function (_x13, _x14) {
      return _ref14.apply(this, arguments);
    };
  }())
};
var getters = {};
var _default = exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};